import React from 'react';
import type { ServiceDetailsAppLayout as ServicedeskServiceDetailsType } from '@atlassian/jira-spa-apps-servicedesk-service-details-with-project-context/src/ui/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyServicedeskServiceDetailsWithProjectContext = lazyForPaint<
	typeof ServicedeskServiceDetailsType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-servicedesk-service-details-with-project-context", jiraSpaEntry: "async-servicedesk-service-details-with-project-context" */ '@atlassian/jira-spa-apps-servicedesk-service-details-with-project-context'
		),
	),
);

const AsyncServicedeskServiceDetailsWithProjectContext = (): React.JSX.Element => (
	<LazyPage
		Page={LazyServicedeskServiceDetailsWithProjectContext}
		pageId="spa-apps/servicedesk/service-details"
		shouldShowSpinner
	/>
);

export default AsyncServicedeskServiceDetailsWithProjectContext;
